// src/pages/portal/Page_StylesAccess/Page_StylesAccess.js
// Puerta de acceso al editor de estilos. Pagina OCULTA (sin enlace; se escribe
// la URL a mano): /portal/teacher/styles-access. Cualquier profesor logueado la
// ve. Pide un correo de diseno autorizado -> envia OTP -> al verificar el codigo
// guarda el grant (por sesion) y habilita el editor.
import React, { useState } from "react";
import { Card, Input, Button, Typography, message, Space } from "antd";
import {
  MailOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../hooks";
import { StylesAccessApi } from "../../../api/stylesAccessApi";
import { useStylesAccessStore } from "../../../store/stylesAccessStore";
import styles from "./Page_StylesAccess.module.scss";

const api = new StylesAccessApi();
const { Title, Text, Paragraph } = Typography;

export function Page_StylesAccess() {
  const navigate = useNavigate();
  const { accessToken } = useAuth();
  const setGrant = useStylesAccessStore((s) => s.setGrant);

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otpToken, setOtpToken] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSend = async () => {
    if (!email.trim()) {
      message.warning("Pon un correo");
      return;
    }
    setBusy(true);
    try {
      const data = await api.sendOtp(accessToken, email.trim().toLowerCase());
      setOtpToken(data.styleOtpToken);
      setStep(2);
      message.success("Se ha enviado un codigo a ese correo");
    } catch (e) {
      message.error(e?.message || "No se pudo enviar el codigo");
    } finally {
      setBusy(false);
    }
  };

  const handleVerify = async () => {
    if (!/^\d{6}$/.test(code)) {
      message.warning("El codigo son 6 digitos");
      return;
    }
    setBusy(true);
    try {
      const data = await api.verifyOtp(accessToken, otpToken, code);
      setGrant({
        grant: data.grant,
        email: data.email,
        isApprover: data.isApprover,
      });
      message.success("Acceso concedido al editor de estilos");
      navigate("/portal/estilos");
    } catch (e) {
      message.error(e?.message || "Codigo incorrecto");
    } finally {
      setBusy(false);
    }
  };

  const handleResend = async () => {
    setBusy(true);
    try {
      await api.resendOtp(accessToken, otpToken);
      message.success("Codigo reenviado");
    } catch (e) {
      message.error(e?.message || "No se pudo reenviar");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.wrap}>
      <Card className={styles.card} variant="outlined">
        <SafetyCertificateOutlined className={styles.icon} />
        <Title level={4} style={{ marginBottom: 4 }}>
          Acceso al editor de estilos
        </Title>
        <Paragraph type="secondary">
          Introduce un correo de diseno autorizado. Te enviaremos un codigo de
          un solo uso para desbloquear el editor en esta sesion.
        </Paragraph>

        {step === 1 ? (
          <Space direction="vertical" style={{ width: "100%" }} size="middle">
            <Input
              prefix={<MailOutlined />}
              placeholder="correo@educa360.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onPressEnter={handleSend}
              size="large"
              autoFocus
            />
            <Button
              type="primary"
              block
              size="large"
              loading={busy}
              onClick={handleSend}
            >
              Enviar codigo
            </Button>
          </Space>
        ) : (
          <Space direction="vertical" style={{ width: "100%" }} size="middle">
            <Text type="secondary">
              Codigo enviado a <strong>{email}</strong>
            </Text>
            <Input
              prefix={<LockOutlined />}
              placeholder="Codigo de 6 digitos"
              value={code}
              maxLength={6}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
              onPressEnter={handleVerify}
              size="large"
              autoFocus
            />
            <Button
              type="primary"
              block
              size="large"
              loading={busy}
              onClick={handleVerify}
            >
              Verificar y entrar
            </Button>
            <Space>
              <Button type="link" onClick={handleResend} disabled={busy}>
                Reenviar codigo
              </Button>
              <Button
                type="link"
                onClick={() => {
                  setStep(1);
                  setCode("");
                }}
              >
                Cambiar correo
              </Button>
            </Space>
          </Space>
        )}
      </Card>
    </div>
  );
}

export default Page_StylesAccess;
